import React from "react";
import StickyHeadTable from "./StickyHeadTable";
import { isMobile } from "react-device-detect";
import dateFormat from "dateformat";
import RecordsBox from "./RecordsBox";
import PageWrapper from "./layout/PageWrapper";

const AdminTickets = function (props) {
  const {
    tickets: items,
    superUser,
    onEdit,
    canEdit,
    onRefreshData,
    onDelete,
    onSMSRequest,
    businessType,
    search,
  } = props;

  const [itemsForSelection, setItemsForSelection] = React.useState([]);

  const handleItemsForSelectionChange = (items) => {
    setItemsForSelection(items);
  };

  const displayedColumnsInitial = [
    { id: "ticketId", label: "#", minWidth: 50, align: "left" },
    { id: "productName", label: "Evénement", minWidth: 60 },
    { id: "ticketCode", label: "Ticket n°", minWidth: 60 },
    { id: "ticketCreated", label: "Créé le", minWidth: 60 },
    { id: "ticketStatus", label: "Status", minWidth: 60 },
    { id: "ticketConsumed", label: "Consommé", minWidth: 60 },
    { id: "saleId", label: "Réf. vente", minWidth: 60 },
    { id: "firstname", label: "Prénom", minWidth: 60 },
    { id: "lastname", label: "Nom", minWidth: 60 },
    { id: "action", label: "Actions", minWidth: isMobile ? 60 : 120 },
  ];

  const displayedColumns = superUser
    ? displayedColumnsInitial
    : displayedColumnsInitial.filter((c) => c.id !== "___FIELDS_TO_EXCLUDE___");

  return (
    <PageWrapper>
      <RecordsBox items={items} itemsForSelection={itemsForSelection} />

      <StickyHeadTable
        search={search}
        businessType={businessType}
        canEdit={canEdit}
        superUser={superUser || true}
        filters={[
          "ticketId",
          "ticketCreated",
          "ticketCode",
          "firstname",
          "lastname",
          "productName",
          "mobile",
          "saleId",
        ]}
        columns={
          isMobile
            ? displayedColumns.filter(
                (c) =>
                  c.id === "ticketCode" ||
                  c.id === "productName" ||
                  c.id === "action"
              )
            : displayedColumns
        }
        data={(items || []).map((i) => ({
          ...i,
          id: i.ticketId,
          ticketCreated: dateFormat(i.ticketCreated, "mmm dS, H:MM"),
          ticketConsumed: i.ticketConsumed
            ? dateFormat(i.ticketConsumed, "mmm dS, H:MM")
            : "",
          ticketStatus: ["1", "4"].includes(i.ticketStatus)
            ? "Valide"
            : "Consommé",
          rawStatus: i.ticketStatus,
        }))}
        onDelete={onDelete}
        onEdit={onEdit}
        onItemsForSelectionChange={handleItemsForSelectionChange}
        onRefreshData={onRefreshData}
        checkboxEnabled={true}
        onSMSRequest={onSMSRequest}
      />
    </PageWrapper>
  );
};

export default AdminTickets;
